/**
 * TicketedEventFaq Entity Schemas
 *
 * Q&A entries rendered as an accordion on the public event page.
 */

import { z } from 'zod'

export const TicketedEventFaqSchema = z.object({
  id: z.string(),
  question: z.string(),
  answer: z.string(),
  sortOrder: z.number().int(),
  createdAt: z.string(),
  updatedAt: z.string().nullable()
})
export type TicketedEventFaq = z.infer<typeof TicketedEventFaqSchema>

export const TicketedEventFaqPublicSchema = z.object({
  id: z.string(),
  question: z.string(),
  answer: z.string(),
  sortOrder: z.number().int()
})
export type TicketedEventFaqPublic = z.infer<typeof TicketedEventFaqPublicSchema>
